module.exports = __webpack_public_path__ + "img/22.f70bbbb6.jpg";